import { useCallback, useMemo } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleLeasingPlan from '../useSingleLeasingPlan';
import { getLeasingPlanViewSections } from '../leasingPlanViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const SingleLeasingPlan = () => {
  const { t } = useTranslation();
  const { singleItem, loading, handleDownload } = useSingleLeasingPlan();

  const onDownloadFile = useCallback(
    (url, fileName) => {
      handleDownload(url, fileName);
    },
    [handleDownload],
  );

  const sections = useMemo(
    () =>
      getLeasingPlanViewSections(t, singleItem, { onDownloadFile }),
    [t, singleItem, onDownloadFile],
  );

  const pageTitle = singleItem?.title || t('LEASING PLANS');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/leasing/plans/${singleItem?.id}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/leasing/plans'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SingleLeasingPlan;
